import { Link } from 'gatsby';
import "../../../../src/pages/design/design-guidelines-styles.css";
import { DemoModal } from "../../../../src/components/DemoModal";
import { DocsHeading } from "../../../../src/components/DocsHeading";
import { LeadParagraph } from "../../../../src/components/LeadParagraph";
import { Button, Modal } from 'react-magma-dom';
import * as React from 'react';
export default {
  Link,
  DemoModal,
  DocsHeading,
  LeadParagraph,
  Button,
  Modal,
  React
};